import service from '@/services';

export type RecoveryAction = 'manage_billing' | 'contact_firm_admin';

export type EntitlementStatus = {
  entitled: boolean;
  enforcement_enabled: boolean;
  override_active: boolean;
  reason: string;
  recovery_action: RecoveryAction | null;
  can_manage_billing: boolean;
};

export type BillingRecoveryAction =
  | 'setup_billing'
  | 'manage_billing'
  | 'update_payment_method'
  | 'resubscribe'
  | 'resume_or_contact_support'
  | 'contact_support';

export type BillingRecoveryState = {
  action: BillingRecoveryAction;
  reason: string;
  entitled: boolean;
  self_service_available: boolean;
  can_manage_billing: boolean;
};

export type BillingRecoverySession = {
  action: BillingRecoveryAction;
  session_type: 'billing_portal' | 'customer_session' | 'billing_setup';
  url: string | null;
  client_secret: string | null;
};

export type BillingEntitlementRefresh = {
  entitled: boolean;
  reason: string;
  subscription_status: string | null;
  snapshot_updated: boolean;
  no_subscription?: boolean;
  update_reason: string;
};

export const getEntitlementStatus = (): Promise<EntitlementStatus> =>
  service.getByParams<EntitlementStatus>('/entitlement');

export const getBillingRecoveryState = (): Promise<BillingRecoveryState> =>
  service.getByParams<BillingRecoveryState>('/billing-recovery');

export const createBillingRecoverySession = (): Promise<BillingRecoverySession> =>
  service.post<BillingRecoverySession>('/billing-recovery/session');

export const refreshBillingEntitlement = (): Promise<BillingEntitlementRefresh> =>
  service.post<BillingEntitlementRefresh>('/billing-recovery/refresh');
